
const auth = {
  'auth.signIn': 'Accedi',
  'auth.signUp': 'Registrati',
  'auth.signOut': 'Disconnetti',
  'auth.profile': 'Profilo',
  'auth.forgotPassword': 'Hai dimenticato la password?',
  'auth.resetPassword': 'Reimposta password',
  'auth.noAccount': 'Non hai un account?',
  'auth.haveAccount': 'Hai già un account?',
  'auth.emailVerification': 'Verifica email',
  'auth.emailVerificationSent': 'È stata inviata un\'email di verifica al tuo indirizzo email. Controlla la tua casella di posta e segui le istruzioni per verificare il tuo account.',
  'auth.emailVerificationInfo': 'Prima di accedere, verifica il tuo indirizzo email.',
  'auth.verificationSuccess': 'La tua email è stata verificata con successo!',
  'auth.verificationError': 'Si è verificato un errore durante la verifica dell\'email.',
  'auth.passwordRequirements': 'La password deve:',
  'auth.passwordLength': 'Essere lunga almeno 8 caratteri',
  'auth.passwordUppercase': 'Includere almeno una lettera maiuscola',
  'auth.passwordLowercase': 'Includere almeno una lettera minuscola',
  'auth.passwordNumber': 'Includere almeno un numero',
  'auth.passwordSpecial': 'Includere almeno un carattere speciale',
  'auth.passwordsDoNotMatch': 'Le password non corrispondono',
  'auth.emailsDoNotMatch': 'Le email non corrispondono',
  'auth.invalidEmail': 'Inserisci un indirizzo email valido',
  'auth.mandatoryField': 'Questo campo è obbligatorio',
  'auth.usernameLength': 'Il nome utente deve avere tra 3 e 20 caratteri',
  'auth.usernameFormat': 'Il nome utente può contenere solo lettere, numeri, underscore e trattini',
  'auth.nameFormat': 'Può contenere solo lettere, spazi, trattini e apostrofi',
  'auth.nameMaxLength': 'Non deve superare i 50 caratteri',
  'auth.phoneFormat': 'Inserisci un numero di telefono valido',
  'auth.addressFormat': 'L\'indirizzo contiene caratteri non validi',
  'auth.addressMaxLength': 'L\'indirizzo non deve superare i 200 caratteri',
  'auth.cityFormat': 'La città può contenere solo lettere, spazi, trattini e apostrofi',
  'auth.cityMaxLength': 'La città non deve superare i 100 caratteri',
  'auth.postalCodeFormat': 'Il CAP può contenere solo lettere, numeri, spazi e trattini',
  'auth.postalCodeMaxLength': 'Il CAP non deve superare i 20 caratteri',
  'auth.emailMaxLength': 'L\'indirizzo email è troppo lungo',
  'auth.passwordMaxLength': 'La password non deve superare i 128 caratteri',
  'auth.phoneMinLength': 'Il numero di telefono è troppo corto',
  'auth.phoneMaxLength': 'Il numero di telefono è troppo lungo',
  'auth.suspiciousContent': 'Contiene contenuti potenzialmente dannosi',
  'auth.reservedUsername': 'Il nome utente è riservato',
  'auth.commonPassword': 'La password è troppo comune',
  'auth.minimumAge': 'Devi avere almeno 18 anni',
  'auth.loginError': 'Email o password non validi',
  'auth.loginRequired': 'Accedi per visualizzare il tuo profilo',
  'auth.signUpError': 'Errore durante la creazione dell\'account',
  'auth.signOutError': 'Errore durante la disconnessione',
  'auth.usernameTaken': 'Il nome utente è già in uso',
  'auth.emailTaken': 'L\'email è già in uso',
  'auth.firstName': 'Nome',
  'auth.lastName': 'Cognome',
  'auth.dateOfBirth': 'Data di nascita',
  'auth.gender': 'Genere',
  'auth.selectGender': 'Seleziona genere',
  'auth.male': 'Maschio',
  'auth.female': 'Femmina',
  'auth.other': 'Altro',
  'auth.preferNotToSay': 'Preferisco non specificare',
  'auth.phone': 'Numero di telefono',
  'auth.phoneNumber': 'Numero di telefono',
  'auth.email': 'Email',
  'auth.confirmEmail': 'Conferma email',
  'auth.username': 'Nome utente',
  'auth.password': 'Password',
  'auth.confirmPassword': 'Conferma password',
  'auth.agreeToTerms': 'Accetto i ',
  'auth.termsOfService': 'Termini di servizio',
  'auth.and': ' e ',
  'auth.privacyPolicy': 'Informativa sulla privacy',
  'auth.termsRequired': 'Devi accettare i Termini e Condizioni',
  'auth.country': 'Paese',
  'auth.selectCountry': 'Seleziona paese',
  'auth.countryCode': 'Prefisso internazionale',
  'auth.selectCountryCode': 'Seleziona prefisso',
  'auth.userInfo': 'Informazioni utente',
  'auth.contactInfo': 'Informazioni di contatto',
  'auth.accountInfo': 'Informazioni account',
  'auth.welcomeBack': 'Accedi a The Club',
  'auth.welcomeMessage': 'Inserisci le tue credenziali per accedere',
  'auth.createAccount': 'Crea il tuo account The Club',
  'auth.createAccountMessage': 'Compila le informazioni qui sotto per creare il tuo account',
  'auth.updateProfile': 'Aggiorna profilo',
  'auth.profileUpdated': 'Profilo aggiornato con successo',
  'auth.profileUpdateError': 'Errore durante l\'aggiornamento del profilo',
  'auth.selectDate': 'Seleziona una data',
  'auth.selectYear': 'Seleziona un anno',

  // Nuove traduzioni per reset password
  'auth.resetPasswordInstructions': 'Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password.',
  'auth.sendResetEmail': 'Invia email di reimpostazione',
  'auth.resetEmailSent': 'Email di reimpostazione inviata',
  'auth.resetEmailInstructions': 'Controlla la tua email per le istruzioni su come reimpostare la password.',
  'auth.resetPasswordError': 'Errore durante la reimpostazione della password',
  'auth.unexpectedError': 'Si è verificato un errore imprevisto',
  'auth.createNewPassword': 'Crea una nuova password per il tuo account',
  'auth.newPassword': 'Nuova password',
  'auth.backToSignIn': 'Torna al login',
  'auth.passwordResetSuccess': 'Password reimpostata con successo',
  'auth.passwordResetSuccessMessage': 'La tua password è stata reimpostata correttamente. Verrai reindirizzato alla pagina di login.',
  'auth.invalidResetLink': 'Link di reimpostazione non valido o scaduto',
  'auth.tooManyAttempts': 'Troppi tentativi di accesso. Riprova più tardi.',

  // Nuove traduzioni per registrazione multi-step
  'auth.signUpWithGoogle': 'Registrati con Google',
  'auth.signUpWithFacebook': 'Registrati con Facebook',
  'auth.orContinueWithEmail': 'Oppure continua con la tua email',
  'auth.next': 'Avanti',
  'auth.back': 'Indietro',
  'auth.stepTwoOfTwo': 'Passo 2 di 2',
  
  // Nuove traduzioni per elementi UI mancanti
  'auth.redirecting': 'Reindirizzamento...',
  'auth.emailPlaceholder': 'tua@esempio.com',
  'auth.emailPlaceholderGeneric': 'email@esempio.com',
  'auth.invalidRecoveryLink': 'Link di recupero non valido. Per favore richiedi un nuovo link di reimpostazione password.',
  'auth.passwordResetTitle': 'Reimposta la tua password',
  'auth.confirmNewPassword': 'Conferma nuova password',
  'auth.resetPasswordSubmit': 'Reimposta password',

  // Messaggi di validazione aggiuntivi
  'auth.emailValidationError': 'Inserisci un indirizzo email valido',
  'auth.passwordValidationMinLength': 'La password deve essere lunga almeno 8 caratteri',
  'auth.passwordValidationUppercase': 'La password deve includere almeno una lettera maiuscola',
  'auth.passwordValidationNumber': 'La password deve includere almeno un numero',
  'auth.passwordValidationSpecial': 'La password deve includere almeno un carattere speciale',
  'auth.passwordValidationMatch': 'Le password non corrispondono',

  // Messaggi specifici per reset password
  'auth.verifyingRecoveryLink': 'Verifica del link di recupero...',
  'auth.unableToVerifySession': 'Impossibile verificare la sessione di recupero. Per favore richiedi un nuovo link di reimpostazione password.',
  'auth.unableToVerifyLink': 'Impossibile verificare il link di recupero. Per favore richiedi un nuovo link di reimpostazione password.',
  'auth.invalidRecoverySession': 'Sessione di recupero non valida. Per favore richiedi un nuovo link di reimpostazione password.',
  'auth.requestNewResetLink': 'Richiedi nuovo link di reimpostazione',

  // Messaggi generali UI
  'auth.emailVerifiedSignIn': 'La tua email è stata verificata. Per favore accedi con le tue credenziali.',
  'auth.unexpectedErrorOccurred': 'Si è verificato un errore imprevisto',

  //Supabase Error Messages
  // Authentication errors
  'auth.supabase.invalidCredentials': 'Email o password non validi',
  'auth.supabase.emailNotConfirmed': 'Verifica il tuo indirizzo email prima di accedere',
  'auth.supabase.userNotFound': 'Nessun account trovato con questo indirizzo email',
  'auth.supabase.passwordTooShort': 'La password deve essere di almeno 6 caratteri',
  'auth.supabase.userAlreadyRegistered': 'Esiste già un account con questa email',
  'auth.supabase.emailRateLimit': 'Troppe email inviate. Attendi prima di richiederne un\'altra',
  'auth.supabase.invalidEmail': 'Inserisci un indirizzo email valido',
  'auth.supabase.signupDisabled': 'La registrazione di nuovi account è attualmente disabilitata',
  'auth.supabase.invalidRecoveryToken': 'Link di recupero password non valido',
  'auth.supabase.tokenExpired': 'Questo link è scaduto. Richiedi un nuovo reset della password',
  'auth.supabase.passwordTooWeak': 'La password è troppo debole. Scegli una password più sicura',
  
  // Database errors
  'auth.supabase.databaseError': 'Errore di connessione al database. Riprova più tardi',
  'auth.supabase.connectionTimeout': 'Timeout della connessione. Controlla la tua connessione internet',
  'auth.supabase.internalError': 'Errore interno del server. Riprova più tardi',
  'auth.supabase.serviceUnavailable': 'Servizio temporaneamente non disponibile. Riprova più tardi',
  'auth.supabase.requestTimeout': 'Timeout della richiesta. Riprova',
  
  // Policy/Permission errors
  'auth.supabase.permissionDenied': 'Accesso negato. Non hai i permessi per eseguire questa azione',
  'auth.supabase.accessDenied': 'Accesso negato',
  'auth.supabase.insufficientPermissions': 'Permessi insufficienti per completare questa azione',
  
  // Network errors
  'auth.supabase.networkError': 'Errore di connessione di rete. Controlla la tua connessione internet',
  'auth.supabase.connectionError': 'Errore di connessione. Riprova',
  
  // Generic patterns
  'auth.supabase.rateLimit': 'Troppe richieste. Attendi un momento prima di riprovare',
  'auth.supabase.invalidToken': 'Token di autenticazione non valido. Accedi di nuovo',
  'auth.supabase.resourceNotFound': 'Risorsa richiesta non trovata',
  'auth.supabase.resourceAlreadyExists': 'Questa risorsa esiste già',
  
  // Generic fallback
  'auth.supabase.genericError': 'Si è verificato un errore imprevisto. Riprova',

  // Invitation code field
  'auth.sponsor': 'Codice Invito',
  'auth.sponsorMandatory': '(obbligatorio)',
  'auth.sponsorPlaceholder': 'Inserisci il tuo codice invito',
  'auth.sponsorNotFound': 'Codice invito non valido. Inserisci un codice valido',
  'auth.sponsorRequired': 'Un codice invito valido è obbligatorio',
  'auth.needSponsor': 'Hai bisogno di un codice invito? Contatta un rappresentante The Club',

  // Email confirmation error
  'auth.confirmationFailed': 'Conferma email non riuscita. Controlla la tua casella di posta per l\'ultimo link di conferma.',
  'auth.resendConfirmationEmail': 'Reinvia email di conferma',
  'auth.resendIn': 'Reinvia tra {{seconds}}',
  'auth.resendSuccess': 'Email di conferma inviata! Controlla la tua casella di posta.',
  'auth.enterEmailToResend': 'Inserisci la tua email per reinviare il link di conferma',

  // Smart confirmation flow
  'auth.emailNeedsConfirmation': 'Questa email deve essere confermata. Un link di conferma è stato inviato di recente — controlla la tua casella di posta.',
  'auth.emailConfirmationResent': 'Questa email deve essere confermata. Una nuova email di conferma è stata inviata — controlla la tua casella di posta per il link più recente.',
  'auth.confirmationRecentlySent': 'Un link di conferma è stato inviato di recente a questa email. Controlla la tua casella di posta.',
  'auth.confirmationNewSent': 'Una nuova email di conferma è stata inviata. Controlla la tua casella di posta per il link di conferma più recente.',
  'auth.confirmationSentTo': 'Email di conferma inviata a:',
  'auth.verifyEmailResendInfo': 'Non hai ricevuto l\'email?',

  // Already confirmed messages
  'auth.emailAlreadyConfirmed': 'Il tuo indirizzo email è già verificato. Puoi accedere con le tue credenziali.',
  'auth.emailAlreadyConfirmedSignIn': 'La tua email è già verificata. Accedi qui sotto.',
};

export default auth;
